import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { useContext } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import OnDarkContext from '../OnDarkContext';

/**
 * `Text` component is used for displaying inline text. For text blocks use [Paragraph](#!/Paragraph).
 * @since 1.1.0
 */
var Text = function Text(_ref) {
  var _classNames;

  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "text") : _ref$baseClassName,
      className = _ref.className,
      children = _ref.children,
      Tag = _ref.component,
      intent = _ref.intent,
      fontSize = _ref.fontSize,
      _ref$bold = _ref.bold,
      bold = _ref$bold === void 0 ? false : _ref$bold,
      _ref$italic = _ref.italic,
      italic = _ref$italic === void 0 ? false : _ref$italic,
      _ref$mark = _ref.mark,
      mark = _ref$mark === void 0 ? false : _ref$mark,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? false : _ref$truncate,
      _ref$nowrap = _ref.nowrap,
      nowrap = _ref$nowrap === void 0 ? false : _ref$nowrap,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "children", "component", "intent", "fontSize", "bold", "italic", "mark", "truncate", "nowrap"]);

  if (!Tag) {
    Tag = mark ? 'mark' : 'span';
  }

  var onDark = useContext(OnDarkContext);
  return React.createElement(Tag, _extends({
    className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--").concat(intent), intent), _defineProperty(_classNames, "".concat(baseClassName, "--").concat(fontSize), fontSize), _defineProperty(_classNames, "".concat(baseClassName, "--bold"), bold), _defineProperty(_classNames, "".concat(baseClassName, "--italic"), italic), _defineProperty(_classNames, "".concat(baseClassName, "--truncate"), truncate), _defineProperty(_classNames, "".concat(baseClassName, "--nowrap"), nowrap), _defineProperty(_classNames, "".concat(baseClassName, "--mark"), mark), _defineProperty(_classNames, "".concat(baseClassName, "--on-dark"), onDark), _classNames), className)
  }, props), children);
};

export default Text;